"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ViewportManager = _interopRequireDefault(require("./ViewportManager"));

var _isStyledComponent2 = _interopRequireDefault(require("../../utils/isStyledComponent"));

var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// import vdsHash from './injectStyles';
var CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

var wrapWithManager = function wrapWithManager(Component) {
  var componentName = Component ? Component.displayName || Component.name : 'Component';
  var isStatelessFunctionalComponent = typeof Component === 'function' && !(Component.prototype && 'isReactComponent' in Component.prototype); // NOTE: We can't pass a ref to a stateless functional component

  var shouldSetInnerRef = (0, _isStyledComponent2["default"])(Component) || isStatelessFunctionalComponent;

  var WithManager = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(WithManager, _React$Component);

    var _super = _createSuper(WithManager);

    function WithManager(props) {
      var _this;

      (0, _classCallCheck2["default"])(this, WithManager);
      _this = _super.call(this, props);
      _this.viewportManager = _ViewportManager["default"];
      _this.state = {
        viewport: undefined
      };
      _this.id = _this._makeid(10);

      _this.viewportManager.subscribe(_this.id, function (vp) {
        _this.setState({
          viewport: vp
        });
      });

      return _this;
    }

    (0, _createClass2["default"])(WithManager, [{
      key: "_makeid",
      value: function _makeid(length) {
        var result = '';
        var charactersLength = CHARACTERS.length;

        for (var i = 0; i < length; i++) {
          var randomNum = Math.random();
          var flooredNum = Math.floor(randomNum * 10);
          result += CHARACTERS.charAt(flooredNum);
        }

        return result;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.setState({
          viewport: this.viewportManager.viewport
        }); //for intial viewport
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.viewportManager.unsubscribe(this.id);
      }
    }, {
      key: "render",
      value: function render() {
        var props = _objectSpread({
          viewport: this.state.viewport
        }, this.props);

        if (!shouldSetInnerRef) {
          props.ref = props.innerRef;
          delete props.innerRef;
        }

        return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary["default"], null, /*#__PURE__*/_react["default"].createElement(Component, props));
      }
    }]);
    return WithManager;
  }(_react["default"].Component);

  (0, _defineProperty2["default"])(WithManager, "displayName", "WithManager(".concat(componentName, ")"));
  return WithManager;
};

var _default = wrapWithManager;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/icons/~/@vds-core/utilities/dist/cjs/components/AppManager/HOC.js
// module id = 1442
// module chunks = 0